export enum InputValueType {
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    EMAIL = 'EMAIL',
    DEPARTAMENT_NAME = 'DEPARTMENT_NAME',
    POSITION = 'POSITION',
}

export enum AttributeType {
    STATIC = 'STATIC',
    DYNAMIC = 'DYNAMIC',
}

export enum ComparisonMethod {
    EXACT_MATCH = 'EXACT_MATCH',
    CONTAINS = 'CONTAINS',
}

export interface Group {
    id: number;
    name: string;
    applicationId: number;
    organizationId: number;
    rules?: GroupRule[];
}

export interface GroupRule {
    [key: string]: any;
    ruleId: number;
    id?: number | null;
    name: string;
    groupId: number;
    items: GroupRuleItem[];
}

export interface GroupRuleItem {
    itemId: number;
    id?: number | null;
    value: string;
    comparisonMethod: ComparisonMethod;
    attributeName: InputValueType;
    groupRuleId: number;
    attributeType: AttributeType;
}
